// Aurora Innovation, Inc. Proprietary and Confidential. Copyright 2026.
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { cardHeaderClasses } from '@mui/material/CardHeader';
import { rem } from '../../tokens/conversions';
import { borderRadius, spacing } from '../../tokens/spacing';
import { cardColors } from './cardColors';
export var Card = function(mode) {
    var c = cardColors(mode);
    var override = {
        MuiCard: {
            styleOverrides: {
                root: {
                    backgroundColor: c.background,
                    color: c.text,
                    border: "".concat(rem(1), " solid ").concat(c.border),
                    borderRadius: rem(borderRadius.default),
                    boxShadow: 'none'
                }
            },
            defaultProps: {
                variant: 'outlined',
                elevation: 0
            }
        },
        MuiCardContent: {
            styleOverrides: {
                root: // A CardHeader already ends with its own bottom padding, so drop this
                // content's top padding when it directly follows one — otherwise the two
                // paddings stack into a double-height gap.
                _define_property({
                    padding: rem(spacing[4]),
                    '&:last-child': {
                        paddingBottom: rem(spacing[4])
                    }
                }, ".".concat(cardHeaderClasses.root, " + &"), {
                    paddingTop: rem(0)
                })
            }
        },
        MuiCardHeader: {
            styleOverrides: {
                root: {
                    padding: rem(spacing[4])
                }
            }
        },
        MuiCardActions: {
            styleOverrides: {
                root: {
                    padding: "".concat(rem(0), " ").concat(rem(spacing[4]), " ").concat(rem(spacing[4])),
                    gap: rem(spacing[2])
                }
            }
        }
    };
    return override;
};

//# sourceMappingURL=Card.js.map